import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from 'react';
import styles from './style.module.scss';
import { Button } from 'components/buttons';
import { SIZE_MEDIUM } from 'constants/sizes';
import { THEME_DARK } from 'constants/color-theme';

export const Accordion = forwardRef((props, ref) => {
  const {
    openedOrClosed,
    handleOpen,
    bgMedia,
    specialContent,
    accordionHeader,
    contentHeader,
    accordionContent,
    buttonLabel,
    buttonLink,
  } = props;

  const [openState, setOpenState] = useState(styles[openedOrClosed]);

  useImperativeHandle(ref, () => ({
    closeAccordion: () => {
      setOpenState(styles['closed']);
    },
  }));

  useEffect(() => {
    setOpenState(styles[openedOrClosed]);
    console.log(openedOrClosed);
  }, [openedOrClosed]);

  const toggleState = () => {
    if (openState === styles['opened']) {
      setOpenState(styles['closed']);
    } else {
      handleOpen();
      setOpenState(styles['opened']);
    }
  };

  let content;

  switch (specialContent) {
    case 'finishes': {
      content = 'Finishes';
      break;
    }
    case 'options-details': {
      content = 'optionsDetails';
      break;
    }
    default: {
      console.log('incorrect content');
    }
  }

  return (
    <div className={styles['accordion'] + ' ' + openState}>
      <div className={styles['underlay']} style={{ backgroundImage: '' }}>
        {bgMedia && bgMedia.type === 'image' && (
          <img alt={bgMedia.caption} src={bgMedia.url} />
        )}
        {bgMedia && bgMedia.type === 'video' && (
          <video playsInline autoPlay loop muted>
            <source src={bgMedia.url} type="video/mp4"></source>
          </video>
        )}
      </div>
      <div>
        <div
          className={styles['closed-contents']}
          onClick={() => {
            toggleState();
          }}
        >
          <h3>{accordionHeader}</h3>
          <span className={styles['closed']}>
            <svg
              width="31"
              height="31"
              viewBox="0 0 31 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="15.5" cy="15.5" r="15" stroke="#A9A9AB" />
              <line
                className={styles['vertical-plus']}
                x1="15.5"
                y1="8"
                x2="15.5"
                y2="23"
                stroke="#A9A9AB"
              />
              <line x1="8" y1="15.5" x2="23" y2="15.5" stroke="#A9A9AB" />
            </svg>
          </span>
        </div>
        {specialContent === (null || '') ? (
          <div className={styles['opened-contents']}>
            <div className={styles['normal-content']}>
              <h3>{contentHeader}</h3>
              <p>{accordionContent}</p>
              <a href={buttonLink} target="_blank" rel="noreferrer">
                <Button
                  label={buttonLabel}
                  size={SIZE_MEDIUM}
                  theme={THEME_DARK}
                ></Button>
              </a>
            </div>
          </div>
        ) : specialContent === 'options-details' ? (
          <div
            className={
              styles['opened-contents'] + ' ' + styles['options-details']
            }
          >
            <div className={styles['normal-content']}>
              <div className={styles['table-holder']}>
                <h4>Options/Accessories Descriptions</h4>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
                  mauris felis, interdum tincidunt leo sed, tincidunt feugiat
                  lacus. Duis pretium, eros quis tempus facilisis,
                </p>
                <table>
                  <tr>
                    <th>Code</th>
                    <th>Label</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td>54</td>
                    <td>IP54 (std)</td>
                    <td>Ingress protection to IP54</td>
                  </tr>
                  <tr>
                    <td>20</td>
                    <td>IP20 (std)</td>
                    <td>Ingress protection to IP20</td>
                  </tr>
                  <tr>
                    <td>65</td>
                    <td>IP65</td>
                    <td>Ingress protection to IP65</td>
                  </tr>
                  <tr>
                    <td>67</td>
                    <td>IP7</td>
                    <td>Ingress protection to IP67</td>
                  </tr>
                  <tr>
                    <td>54</td>
                    <td>IP54 (std)</td>
                    <td>Ingress protection to IP54</td>
                  </tr>
                  <tr>
                    <td>20</td>
                    <td>IP20 (std)</td>
                    <td>Ingress protection to IP20</td>
                  </tr>
                  <tr>
                    <td>65</td>
                    <td>IP65</td>
                    <td>Ingress protection to IP65</td>
                  </tr>
                  <tr>
                    <td>67</td>
                    <td>IP7</td>
                    <td>Ingress protection to IP67</td>
                  </tr>
                  <tr>
                    <td>54</td>
                    <td>IP54 (std)</td>
                    <td>Ingress protection to IP54</td>
                  </tr>
                  <tr>
                    <td>20</td>
                    <td>IP20 (std)</td>
                    <td>Ingress protection to IP20</td>
                  </tr>
                  <tr>
                    <td>65</td>
                    <td>IP65</td>
                    <td>Ingress protection to IP65</td>
                  </tr>
                  <tr>
                    <td>67</td>
                    <td>IP7</td>
                    <td>Ingress protection to IP67</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        ) : (
          content
        )}
      </div>
    </div>
  );
});
